import { useEffect, useRef } from "react";
import Image from "next/image";
import useOutsideClick from "@/hooks/useOutsideClick";
import { makeApiImage } from "@/libs/clientConfig";
import NextImageWithLoader from "../NextImageWithLoader";

type Props = {
  showImageModalIsOpened: boolean;
  setShowImageModalIsOpened: Function;
  data: any;
};

const ShowImageModalIsOpened = ({
  showImageModalIsOpened,
  setShowImageModalIsOpened,
  data,
}: Props) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useOutsideClick(modalRef, showImageModalIsOpened, setShowImageModalIsOpened);

  return (
    <div className="fixed top-0 left-0 w-full h-screen overflow-x-hidden overflow-y-scroll inset-0 z-50 outline-none focus:outline-none">
      <div
        className="relative w-full vs:w-5/6 lg:w-[1154px] mx-auto bg-white opacity-100"
        ref={modalRef}
      >
        <div
          className="fixed top-0 left-1/12 w-full vs:w-5/6 lg:w-[1154px] h-[70px] bg-white flex items-center px-8 hover:underline cursor-pointer"
          onClick={() => {
            setShowImageModalIsOpened(false);
            document.body.style.overflowY = "scroll";
          }}
        >
          <div className="flex">
            <span>
              <Image
                className="mt-[6px]"
                width={14}
                height={14}
                src="/assets/listings/arrow.png"
                alt="back"
              />
            </span>
            <span className="text-[#727a82]">&nbsp;&nbsp;Back to listing</span>
          </div>
        </div>
        <div className="mt-[70px]">
          {(data?.uploadImages || []).map((item: any, index: number) => {
            return (
              <div
                className="w-full lg:w-[1154px] h-auto mb-8"
                key={item.images}
              >
                <NextImageWithLoader
                  className="w-full h-full cursor-pointer object-contain"
                  src={makeApiImage(
                    item.images,
                    "/assets/imagePlaceholder.svg"
                  )}
                  width={900}
                  height={675}
                  key={item.id}
                  alt="car_image_1250x1000"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ShowImageModalIsOpened;
